import { SubscriptionAPI } from 'dva';
import type {
  ResourceCreatorPageModelType,
  CollectionCreatorPageModelState,
  ChangeAction,
} from './types';
import { initialState } from './initialState';
import { pageEffects } from './pageEffects';
import { step1Effects } from './step1Effects';
import { step2Effects } from './step2Effects';
import { step3Effects } from './step3Effects';
import { step4Effects } from './step4Effects';

export type { CollectionCreatorPageModelState };
export * from './types';
export { initialState };

const Model: ResourceCreatorPageModelType = {
  namespace: 'collectionCreatorPage',
  state: initialState,
  effects: {
    ...pageEffects,
    ...step1Effects,
    ...step2Effects,
    ...step3Effects,
    ...step4Effects,
  },
  reducers: {
    change(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  subscriptions: {
    setup({ dispatch, history }: SubscriptionAPI) {},
  },
};

export default Model;
